import { UserGroups } from '@thx/enums';
import { IUser } from '@thx/interfaces';
import { AuthUser, AuthSession } from 'aws-amplify/auth';

export class UserConverter {
  convertUser(authSession: AuthSession, authUser: AuthUser): IUser {
    const groups: UserGroups[] = (authSession.tokens?.accessToken?.payload['cognito:groups'] as UserGroups[]).filter(
      (group) => !group.includes('Google') || group.includes('Facebook'),
    );
    const user = {
      sub: authSession.tokens?.accessToken?.payload?.sub,
      email: authSession.tokens?.idToken?.payload['email'] as string,
      groups,
    };

    return user;
  }
}
